module.exports = __webpack_public_path__ + "img/charlies.c710ce9.png";